import { Game } from 'types'
import audioGame3 from 'assets/sounds/a-noite-no-castelo.mp3'
import audioGame6 from 'assets/sounds/composicao-com-gravuras.mp3'

export const gameListPt: Game[] = [
  {
    id: '1',
    gameTitle: 'Jogo 1',
    content: [
      {
        text: 'Pergunta e Resposta com cordas soltas em pizzicato',
        style: ['title1'],
      },
      {
        text: 'Autoria: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Propiciar aos estudantes a consciência da sua individualidade e seu papel dentro do coletivo; estabelecer as ideias de narrativa musical e de perguntas e respostas, enfatizando o uso das quatro cordas do violoncelo, do pizzicato, de diferentes ritmos, métricas, timbres e dinâmicas.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em um semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Explicar aos estudantes o que poderia ser uma pergunta e o que poderia ser uma resposta dentro de uma narrativa musical.',
        style: ['itemList'],
      },
      {
        text:
          'Exemplificar utilizando apenas as cordas soltas do violoncelo, contemplando diferentes ritmos, métricas, dinâmicas e variações de caráter.',
        style: ['itemList'],
      },
      {
        text:
          'Propor uma pergunta ao primeiro estudante, que deve tocar uma resposta. Em seguida fazer o mesmo em relação ao segundo estudante, e assim sucessivamente, abordando à todos os estudantes, um a um, individualmente.',
        style: ['itemList'],
      },
      {
        text: 'Realizar algumas rodadas do jogo.',
        style: ['itemList'],
      },
      {
        text: 'Organizar os estudantes em duplas, dispostos em diferentes pontos da sala.',
        style: ['itemList'],
      },
      {
        text:
          'Um estudante de cada dupla deve fazer as perguntas e o outro estudante deve fazer as respostas durante alguns minutos.',
        style: ['itemList'],
      },
      {
        text: 'Alternar os papeis da atividade anterior.',
        style: ['itemList'],
      },
      {
        text: 'Organizar novamente a turma em semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Cada dupla vem ao centro do semicírculo e realiza algumas séries de perguntas e respostas, apresentando-as para seus colegas de classe.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Proporcionar aos estudantes autonomia de decisão quanto ao número de perguntas e respostas que eles apresentarão aos seus colegas, quanto a distribuição dos papeis e quanto a combinações entre eles que determinem o início e fim da apresentação aos colegas.',
        style: ['itemList'],
      },
      {
        text:
          'Se observa, com frequência, um aumento de complexidade na elaboração das perguntas e respostas dos estudantes ao longo das atividades.É interessante enfatizar esse fato.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '2',
    gameTitle: 'Jogo 2',
    content: [
      {
        text: 'Sinal Verde X Sinal Vermelho',
        style: ['title1'],
      },
      {
        text: 'Autoria: Maria Teresa Alencar de Brito/Murray Schafer',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabalhar as diferenças entre som e silêncio, bem como sua importância e papel dentro da construção musical; aprofundar a importância da coletividade dentro do processo musical; estabelecer a ideia de diálogo musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em um semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Propor aos estudantes que explorem diferentes sonoridades dos seus violoncelos, através das técnicas estendidas.',
        style: ['itemList'],
      },
      {
        text:
          'Apresentar uma determinada sonoridade e propor que os estudantes, em conjunto, a reproduzam.',
        style: ['itemList'],
      },
      {
        text:
          'Estimular os estudantes a explorarem, individualmente, os seus instrumentos, buscando novas sonoridades.',
        style: ['itemList'],
      },
      {
        text:
          'Cada estudante deverá apresentar uma sonoridade pesquisada aos demais colegas da turma, que devem, em conjunto, reproduzi-la.',
        style: ['itemList'],
      },
      {
        text:
          'Apresentar dois pequenos cartazes aos estudantes, um da cor verde e outro da cor vermelha. Associar os cartazes com as regras de trânsito, sendo que verde significará “tocar” e vermelho significará “não tocar”.',
        style: ['itemList'],
      },
      {
        text:
          'Executar algumas combinações com os cartazes, propondo que os estudantes toquem quaisquer sons que desejarem.',
        style: ['itemList'],
      },
      {
        text:
          'Propor algumas variações de dinâmica, dependendo da sequência que os cartazes forem apresentados aos estudantes.',
        style: ['itemList'],
      },
      {
        text:
          'Escolher um estudante para ser o “maestro” dos demais, cabendo a ele a função de apresentar os cartazes aos colegas.',
        style: ['itemList'],
      },
      {
        text:
          'Dividir a turma em dois grupos, escolhendo um “maestro” por grupo, sendo que cada “maestro” receberá um conjunto de cartazes verde e vermelho.',
        style: ['itemList'],
      },
      {
        text:
          'Cada grupo deverá seguir as indicações dos seus respectivos “maestros” que devem se comunicar de maneira não verbal e proporcionar a interação e o diálogo musical entre os dois grupos.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Devemos estar atentos e estimular o poder de escuta dos estudantes ressaltando que as diferentes combinações de sons e silêncios estabelecidas entre os “maestros” proporcionam a criação de uma narrativa musical.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '3',
    gameTitle: 'Jogo 3',
    content: [
      {
        text: 'A noite no castelo',
        style: ['title1'],
      },
      {
        text: 'Autoria: Claudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Estabelecer relações entre o imaginário e o sonoro; reforçar a confiança entre pares; desenvolver o poder de escolha dentro da criação musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text:
          'Contar uma história aos estudantes sobre um viajante que chega em um castelo mal-assombrado em meio a uma noite de tempestade',
        style: ['itemList'],
      },
      {
        text:
          'Inventariar sons que poderiam compor esta paisagem (trovões, rajadas de vento, som da chuva, morcegos, fantasmas, etc) assim como objetos que estariam dentro do castelo (quadros, vasos, móveis antigos, etc).',
        style: ['itemList'],
      },
      {
        text:
          'Distribuir os estudantes em diferentes pontos da sala, com uma certa distância entre eles.',
        style: ['itemList'],
      },
      {
        text:
          'Escolher um dos estudantes para representar o viajante. Este estudante fará uma caminhada pelo castelo evitando bater nos “objetos”, guiado por sua audição. Quando o viajante se aproximar de um objeto do castelo, o estudante que representa este objeto executará o seu som específico. À medida que o viajante se afastar do objeto, o som diminui de intensidade, e o estudante que estiver mais próximo do viajante começará a executar o som correspondente ao seu objeto, e assim sucessivamente, compondo uma narrativa musical.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'A fim de estimular os estudantes a intensificarem seu poder de escuta, propor que o viajante permaneça mais tempo na frente do objeto que quer ouvir ou que volte a um determinado objeto que deseja ouvir novamente, exercendo papel ativo na composição da narrativa.',
        style: ['itemList'],
      },
      {
        style: ['audio'],
        audio: audioGame3,
      },
    ],
  },
  {
    id: '4',
    gameTitle: 'Jogo 4',
    content: [
      {
        text: 'Assinatura Musical',
        style: ['title1'],
      },
      {
        text: 'Autoria: Wanderson Cruz',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Possibilitar a experiência de criação a partir de células musicais pré-estabelecidas; estabelecer as diferenças entre polifonias e homofonias; incentivar o poder de escolha dentro da criação musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em um semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Perguntar aos estudantes o que é uma assinatura e relacionar as respostas com o que poderia ser uma assinatura musical.',
        style: ['itemList'],
      },
      {
        text:
          'Dar um exemplo utilizando para isso sons provenientes das técnicas tradicionais e das técnicas estendidas.',
        style: ['itemList'],
      },
      {
        text:
          'Propor que os estudantes, individualmente, criem suas assinaturas musicais utilizando os sons que desejarem e as apresentem para os demais colegas da turma.',
        style: ['itemList'],
      },
      {
        text:
          'Propor que os estudantes executem suas assinaturas mais de uma vez, a fim de que possamos verificar se elas se mantem as mesmas nas duas execuções.',
        style: ['itemList'],
      },
      {
        text:
          'Escolher um dos estudantes da turma para ser o “maestro” que deverá compor uma música utilizando apenas as assinaturas musicais elaboradas pelos estudantes.',
        style: ['itemList'],
      },
      {
        text:
          'O “maestro” deve criar sinais que indiquem quando um estudante deve começar a tocar sua assinatura, quando deve parar, com qual intensidade, velocidade e outras variáveis, além de indicar quantos estudantes devem tocar simultaneamente, criando diálogos, interações e diferentes combinações entre as assinaturas.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Estimular os estudantes a trabalharem a escuta e a escolha artística frente ao material apresentado pelos colegas. Dessa forma, evitar que o jogo se torne mecânico e proporcionar a construção de uma ideia musical consistente.',
        style: ['itemList'],
      },
      {
        text:
          'É interessante, em todos os jogos, que o professor seja o "maestro" na primeira rodada, porém, em seguida, escolher diferentes estudantes para assumirem essa função e possibilitar que todos os estudantes do grupo possam, em algum momento, participar como "maestros" de algum dos jogos de improvisação.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '5',
    gameTitle: 'Jogo 5',
    content: [
      {
        text: 'Igual X Parecido X Diferente',
        style: ['title1'],
      },
      {
        text: 'Autoria: Violeta Gainza',
        style: ['paragraph'],
      },
      {
        text: 'Adaptação: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabalhar as ideias de similaridade e diferença em música; proporcionar a criação a partir de um elemento dado previamente; desenvolver a ideia de frases e de narrativas musicais.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em um semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Apresentar três pequenos cartazes. Em um cartaz deverá estar representado o sinal matemático de igual, em outro o sinal de diferente e em outro o sinal de parecido.',
        style: ['itemList'],
      },
      {
        text:
          'O primeiro estudante deve criar livremente uma frase musical, utilizando para isso os sons que desejar.',
        style: ['itemList'],
      },
      {
        text:
          'O professor escolhe um dos cartazes e mostra ao segundo estudante que deve seguir as instruções contidas no cartaz, tocando, assim, uma frase igual, parecida ou diferente da frase criada pelo primeiro estudante.',
        style: ['itemList'],
      },
      {
        text:
          'Apresentar um dos cartazes ao terceiro estudante que deverá executar sua frase seguindo as instruções do cartaz e fazendo referência à frase executada pelo segundo estudante e assim por diante. O jogo segue essa dinâmica até que todos os estudantes tenham participado de algumas rodadas do jogo.',
        style: ['itemList'],
      },
      {
        text:
          'Escolher um dos estudantes para ser o “maestro” e assumir a função de apresentar os cartazes aos demais colegas. Podemos acrescentar mais complexidade nesta rodada do jogo propondo que o “maestro”, além de escolher os cartazes, escolha também qual estudante executará a nova frase. Para isso o “maestro” deve utilizar sinais de linguagem não verbal.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Ao acrescentarmos mais complexidade na variação do jogo propiciamos que os estudantes desenvolvam mais atenção na escuta.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '6',
    gameTitle: 'Jogo 6',
    content: [
      {
        text: 'Composição com gravuras e escrita com notação própria',
        style: ['title1'],
      },
      {
        text: 'Autoria: Diversos autores',
        style: ['paragraph'],
      },
      {
        text: 'Adaptação: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          '​Aproximar os estudantes da ideia de composição; desenvolver uma simbologia própria que represente suas ideias musicais; fazer contato com diferentes maneiras de escrita e representação musical; chamar a atenção para as limitações existentes em qualquer tipo de escrita musical; aproximar compositores e intérpretes.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text:
          'Solicitar que na aula anterior os estudantes tragam gravuras, imagens ou fotos para realizar uma criação coletiva.',
        style: ['itemList'],
      },
      {
        text: 'Dividir a turma em grupos de cinco ou seis estudantes.',
        style: ['itemList'],
      },
      {
        text:
          'Cada grupo deve examinar as gravuras e imagens e criar uma história que pode ser decorrente de quantas imagens o grupo escolher. Esse número pode variar entre os diferentes grupos.',
        style: ['itemList'],
      },
      {
        text:
          'Propor aos estudantes que criem uma história que apresente um enredo contendo início, meio e final.',
        style: ['itemList'],
      },
      {
        text:
          'Propor aos estudantes que escolham diferentes sons e suas combinações para que a história criada por eles possa ser representada apenas através da música.',
        style: ['itemList'],
      },
      {
        text:
          'Após a criação da música, distribuir para cada grupo uma cartolina, uma caixa de lápis de cor e alguns outros materiais, como por exemplo, fitas coloridas, palitos de dente, pedrinhas, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Cada grupo deverá “escrever” a sua música, utilizando para isso os sinais que desejar, desenhos, palavras, símbolos, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Após a escrita da música cada grupo deverá ensaiar algumas vezes sua composição, utilizando ou não o apoio da partitura.',
        style: ['itemList'],
      },
      {
        text: 'Propor que cada grupo apresente aos colegas a sua música.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Dar autonomia aos estudantes durante o processo de criação da história e da música para que eles mesmos se organizem e estabeleçam relações entre si, estimulando assim, que todos participem deste processo.',
        style: ['itemList'],
      },

      {
        text:
          'Dar autonomia aos estudantes durante seus ensaios e durante a apresentação. Os grupos podem escolher como farão esta apresentação, contando ou não a história criada, apresentando ou não a partitura.',
        style: ['itemList'],
      },
      {
        text:
          'Estimular que a comunicação entre os estudantes seja estabelecida de forma não verbal durante a apresentação da música.',
        style: ['itemList'],
      },
      {
        text:
          'De igual maneira devemos dar autonomia aos estudantes durante seus ensaios e durante a apresentação, sendo que os grupos podem escolher como farão esta apresentação, contando ou não a história criada, apresentando ou não a partitura.',
        style: ['itemList'],
      },
      {
        text:
          'Devemos estimular que a comunicação entre os estudantes seja estabelecida de forma não-verbal durante a apresentação da música.',
        style: ['itemList'],
      },
      {
        audio: audioGame6,
        style: ['audio'],
      },
    ],
  },
  {
    id: '7',
    gameTitle: 'Jogo 7',
    content: [
      {
        text: 'Improvisação com ostinato',
        style: ['title1'],
      },
      {
        text: 'Autoria: Diversos autores',
        style: ['paragraph'],
      },
      {
        text: 'Adaptação: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabalhar a noção de solo e tutti; trabalhar a ideia de ostinato; trabalhar o conceito de forma musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em um semicírculo.',
        style: ['itemList'],
      },
      {
        text: 'Explicar aos estudantes o que é um ostinato.',
        style: ['itemList'],
      },
      {
        text:
          'Propor um ostinato ritmico simples, a ser executado, por exemplo, com uma corda solta.',
        style: ['itemList'],
      },
      {
        text: 'Dividir o grupo em orquestra e solista.',
        style: ['itemList'],
      },
      {
        text:
          'O grupo que representa a orquestra deve executar o ostinato. O estudante solista executa diferentes frases ou ideias musicais utilizando os sons que desejar.',
        style: ['itemList'],
      },
      {
        text: 'Combinar com os estudantes qual será a indicação que determinará o final do solo.',
        style: ['itemList'],
      },
      {
        text:
          'Após a execução do solo por um estudante, o estudante seguinte passa a ser o solista, e assim sucessivamente até que todos os estudantes tenham participado no papel de solistas.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Durante os solos não é necessário pensar em harmonia ou condução vocal, pois a improvisação não necessita obedecer aos padrões do tonalismo.',
        style: ['itemList'],
      },
      {
        text:
          'A improvisação pode ser organizada de diferentes maneiras, por exemplo, estabelecer que após o final de cada solo se executará um número determinado de vezes o ostinato, ou propor uma forma rondó, onde a parte A será um número fixo de vezes que a orquestra executará o ostinato, ou um tema criado em conjunto pelos estudantes, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Acrescentar complexidades no decorrer das jogadas, intercalando-as com audições coletivas das improvisações criadas pelos estudantes.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '8',
    gameTitle: 'Jogo 8',
    content: [
      {
        text: 'A floresta encantada',
        style: ['title1'],
      },
      {
        text: 'Autoria: Claudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text: 'Trabalhar o diálogo musical; trabalhar a ideia de polifonia.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text:
          'Este jogo é uma variação do Jogo 3 (A noite no castelo) sendo acrescentadas algumas complexidades.',
        style: ['itemList'],
      },
      {
        text:
          'Posicionar os estudantes em diferentes pontos da sala com alguma distância entre eles.',
        style: ['itemList'],
      },
      {
        text: 'Contar uma história sobre dois exploradores que chegam a uma floresta encantada.',
        style: ['itemList'],
      },
      {
        text:
          'Cada árvore da floresta emitirá um som escolhido pelos estudantes que a representará.',
        style: ['itemList'],
      },
      {
        text: 'Os exploradores podem estar com os olhos abertos ou vendados.',
        style: ['itemList'],
      },
      {
        text:
          'Ao se aproximarem das árvores, elas emitem o som escolhido pelo estudante que a representa. Ao se afastarem a intensidade do som vai diminuindo e o estudante que estiver mais próximo começa a emitir o som escolhido por ele.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Devemos acrescentar algumas diferenças e complexidades neste jogo em relação ao jogo 3.',
        style: ['itemList'],
      },
      {
        text:
          'Uma das complexidades que podem ser acrescentadas é a participação de dois “maestros”, o que resultará em interações e diálogos musicais entre eles.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '9',
    gameTitle: 'Jogo 9',
    content: [
      {
        text: 'Passeio no zoológico',
        style: ['title1'],
      },
      {
        text: 'Autoria: Violeta Gainza',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabalhar diferentes possibilidades musicais de uma mesma sonoridade; trabalhar a ideia de narrativa musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Contar aos estudantes uma história de um visitante que chega a um zoológico e observa os diferentes animais.',
        style: ['itemList'],
      },
      {
        text:
          'Cada estudante escolhe um animal para ser representado por ele, escolhendo sons que o caracterizem.',
        style: ['itemList'],
      },
      {
        text:
          'O visitante realiza um passeio pelo zoológico, se posicionando frente aos diferentes animais e, nesse momento, os animais reproduzem o som escolhido pelos estudantes.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Propor que os animais emitam os seus sons de acordo com as indicações corporais do visitante, que deve executar diferentes níveis de dinâmica, intensidade e caráter musical.',
        style: ['itemList'],
      },
      {
        text:
          'Assim como nos jogos anteriores, é interessante gravar as improvisações possibilitando que nas próximas rodadas dos jogos as interações sejam mais conscientes e decorrentes das escolhas musicais dos estudantes.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '10',
    gameTitle: 'Jogo 10',
    content: [
      {
        text: 'Os pássaros e o caçador',
        style: ['title1'],
      },
      {
        text: 'Autoria: Cláudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Adaptação: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabalhar a liberdade e as diferentes opções para o início, para o desenvolvimento e para o final da “peça” musical; trabalhar questões ligadas à ecologia e à ecologia acústica; trabalhar os diálogos, as polifonias e a noção de forma musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodologia:',
        style: ['title2'],
      },
      {
        text: 'Organizar os estudantes em um semicírculo.',
        style: ['itemList'],
      },
      {
        text: 'Perguntar aos estudantes quais sons de pássaros eles conhecem.',
        style: ['itemList'],
      },
      {
        text: 'Inventariar junto aos estudantes alguns desses sons.',
        style: ['itemList'],
      },
      {
        text:
          'Propor que os estudantes criem nos seus violoncelos sons que representem os inventariados previamente.',
        style: ['itemList'],
      },
      {
        text: 'Criar em conjunto com os estudantes um som que represente o caçador.',
        style: ['itemList'],
      },
      {
        text:
          'Cada estudante atuará representando o som de um dos pássaros e um estudante representará o caçador.',
        style: ['itemList'],
      },
      {
        text: 'Os pássaros devem dialogar entre si criando um contexto musical.',
        style: ['itemList'],
      },
      {
        text:
          'Quando desejar, o estudante que representa o caçador pode intervir na mata. Quando o caçador intervir, todos os pássaros se calam.',
        style: ['itemList'],
      },
      {
        text: 'Pouco a pouco, os pássaros voltam a cantar e a dialogar entre si.',
        style: ['itemList'],
      },
      {
        text: 'O caçador pode intervir na mata o número de vezes que desejar.',
        style: ['itemList'],
      },
      {
        text: 'Observações:',
        style: ['title2'],
      },
      {
        text:
          'Proporcionar autonomia aos estudantes, deixando a seu critério quando será o início e o final da improvisação, bem como, depois de quanto tempo após a intervenção do caçador os pássaros voltarão a cantar.',
        style: ['itemList'],
      },
    ],
  },
]
